import { render, staticRenderFns } from "./skills-gallery.vue?vue&type=template&id=0220af0e&scoped=true"
import script from "./skills-gallery.vue?vue&type=script&lang=js"
export * from "./skills-gallery.vue?vue&type=script&lang=js"
import style0 from "./skills-gallery.vue?vue&type=style&index=0&id=0220af0e&prod&lang=scss"
import style1 from "./skills-gallery.vue?vue&type=style&index=1&id=0220af0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0220af0e",
  null
  
)

export default component.exports